module.exports = __webpack_public_path__ + "img/me.299c5087.jpg";